import { createAction, props } from '@ngrx/store';
// import { FundingEntity } from './funding.models';
import { TError } from '@amwager/util-ts';
import { IAccountACH, IDebitCreditCard } from './funding.models';

// export const initFunding = createAction('[Funding Page] Init');

/**
 * State
 */
export const initFundingState = createAction(
  '[Funding] Init State',
  props<{
    sourceInitiator: string
  }>()
);
export const clearFundingState = createAction(
  '[Funding] Clear State',
  props<{
    sourceInitiator: string
  }>()
);

export const loadFundingStateSuccess = createAction(
  '[Funding] Load Funding State Success'
);

export const loadFundingStateFailure = createAction(
  '[Funding] Load Funding State Failure',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ error: any }>()
);

/**
 * GET Request
 */
export const depositDebitCreditAPI = createAction(
  '[Funding_API] Deposit amount debit credit card',
  props<{
    amount: number,
    orderId?: string,
    tmsId?: string
  }>()
);

export const withdrawDebitCreditAPI = createAction(
  '[Funding_API] Withdraw amount debit credit card',
  props<{
    amount: number,
    orderId?: string,
    tmsId?: string
  }>()
);

export const getDebitCreditAPI = createAction(
  '[Funding_API] Get debit credit card'
);

export const addDebitCreditAPI = createAction(
  '[Funding_API] Add debit credit card',
  props<{
    card: IDebitCreditCard
  }>()
);

// export const addDebitCreditAPI = createAction(
//   '[Funding_API] Add debit credit card',
//   props<{
//     orderId: string,
//     id: string,
//     paypageRegistrationId: string,
//     bin: number,
//     expMonth: number,
//     expYear: number,
//     firstSix: number,
//     lastFour: number,
//     invokeMerchantCallback: boolean,
//     message: string,
//     reportGroup: string,
//     response: string,
//     responseTime: string,
//     targetServer: string,
//     Type: string,
//     vantivTxnId: string
//   }>()
// );

export const deleteDebitCreditAPI = createAction(
  '[Funding_API] Delete debit credit card',
  props<{
    orderId: string
  }>()
);

export const getTransactionFeeAPI = createAction(
  '[Funding_API] Get Transaction Fee for Debit/Credit ',
  props<{
    method?: string,
    isDeposit: boolean,
    amount: number
  }>()
);

export const depositPromoCodeAPI = createAction(
  '[Funding_API] Deposit promo code',
  props<{
    promoCode: string
  }>()
);

export const depositMoneyPakAPI = createAction(
  '[Funding_API] Deposit Money Pak',
  props<{
    moneyPakNumber: string
  }>()
);

export const depositCryptoCurrencyAPI = createAction(
  '[Funding_API] Deposit crypto currency',
  props<{
    amount: number
  }>()
);

export const getAchAccountAPI = createAction(
  '[Funding_API] Get ach accounts'
);

export const getFundingLimitAPI = createAction(
  '[Funding_API] Get funding limits'
);

export const getPendingAchAPI = createAction(
  '[Funding_API] Get pending ach'
);

export const getHeldWithdrawalsAPI = createAction(
  '[Funding_API] Get held withdrawals'
);

export const depositOnlineCheckAPI = createAction(
  '[Funding_API] Deposit online check',
  props<{
    amount: number,
    bankAccountId: string | number,
    tmsId?: string
  }>()
);

export const addAchAccountAPI = createAction(
  '[Funding_API] Add ach account',
  props<{
    account: IAccountACH
  }>()
);

export const deleteAchAccountAPI = createAction(
  '[Funding_API] Delete ach account',
  props<{
    accountId: string | number
  }>()
);

export const withdrawCheckByEmailAPI = createAction(
  '[Funding_API] Withdraw amount using check by email',
  props<{
    method: string
    amount: number,
  }>()
);

export const withdrawOnlineCheckAPI = createAction(
  '[Funding_API] Withdraw online check',
  props<{
    amount: number,
    bankAccountId: string | number,
    tmsId?: string
  }>()
);

/**
 * GET Response SUCCESS
 */
export const depositDebitCreditAPISuccess = createAction(
  '[Funding_API] Deposit debit credit card Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const withdrawDebitCreditAPISuccess = createAction(
  '[Funding_API] Withdraw debit credit card Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const getDebitCreditAPISuccess = createAction(
  '[Funding_API] Get debit credit card Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const addDebitCreditAPISuccess = createAction(
  '[Funding_API] Add debit credit card Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ newCard: IDebitCreditCard, successResponse: any }>()
);

export const deleteDebitCreditAPISuccess = createAction(
  '[Funding_API] Delete debit credit card Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  // props<{ successResponse: any }>()
  props<{ orderId: string, successResponse: any }>()
);

export const getTransactionFeeAPISuccess = createAction(
  '[Funding_API] Get Transaction Fee for Debit/Credit Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const depositPromoCodeAPISuccess = createAction(
  '[Funding_API] Deposit promo code Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const depositCryptoCurrencyAPISuccess = createAction(
  '[Funding_API] Deposit crypto currency Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const depositMoneyPakAPISuccess = createAction(
  '[Funding_API] Deposit moneypak Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const getFundingLimitAPISuccess = createAction(
  '[Funding_API] Get funding limit Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const getPendingAchAPISuccess = createAction(
  '[Funding_API] Get pending ach Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const getHeldWithdrawalsAPISuccess = createAction(
  '[Funding_API] Get held withdrawals Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const addPendingAch = createAction(
  '[Funding_API] Add to pending ach list',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{
    pendingDeposit: any,
    successResponse: any
  }>()
);

export const depositOnlineCheckAPISuccess = createAction(
  '[Funding_API] Deposit online check ACH Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const getAchAccountAPISuccess = createAction(
  '[Funding_API] Get ach accounts Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const addAchAccountAPISuccess = createAction(
  '[Funding_API] Add ach account Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ newAccount: IAccountACH, successResponse: any }>()
);

export const deleteAchAccountAPISuccess = createAction(
  '[Funding_API] Delete ach account Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  // props<{ successResponse: any }>()
  props<{ accountId: string | number, successResponse: any }>()
);

export const withdrawCheckByEmailAPISuccess = createAction(
  '[Funding_API] Withdraw amount using check by email Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

export const withdrawOnlineCheckAPISuccess = createAction(
  '[Funding_API] Withdraw online check ACH Success',
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  props<{ successResponse: any }>()
);

/**
 * GET Response ERROR
 */
export const depositDebitCreditAPIFailed = createAction(
  '[Funding_API] Deposit debit credit card Failed',
  props<{ errorResponse: TError }>()
);

export const withdrawDebitCreditAPIFailed = createAction(
  '[Funding_API] Withdraw debit credit card Failed',
  props<{ errorResponse: TError }>()
);

export const getDebitCreditAPIFailed = createAction(
  '[Funding_API] Get debit credit card Failed',
  props<{ errorResponse: TError }>()
);

export const addDebitCreditAPIFailed = createAction(
  '[Funding_API] Add debit credit card Failed',
  props<{ errorResponse: TError }>()
);

export const deleteDebitCreditAPIFailed = createAction(
  '[Funding_API] Delete debit credit card Failed',
  props<{ errorResponse: TError }>()
);

export const getTransactionFeeAPIFailed = createAction(
  '[Funding_API] Get Transaction Fee for Debit/Credit Failed',
  props<{ errorResponse: TError }>()
);

export const depositPromoCodeAPIFailed = createAction(
  '[Funding_API] Deposit promo code Failed',
  props<{ errorResponse: TError }>()
);

export const depositMoneyPakAPIFailed = createAction(
  '[Funding_API] Deposit moneypak Failed',
  props<{ errorResponse: TError }>()
);

export const depositCryptoCurrencyAPIFailed = createAction(
  '[Funding_API] Deposit crypto currency Failed',
  props<{ errorResponse: TError }>()
);

export const getAchAccountAPIFailed = createAction(
  '[Funding_API] Get ach accounts Failed',
  props<{ errorResponse: TError }>()
);

export const getFundingLimitAPIFailed = createAction(
  '[Funding_API] Get funding limit Failed',
  props<{ errorResponse: TError }>()
);

export const getPendingAchAPIFailed = createAction(
  '[Funding_API] Get pending ach Failed',
  props<{ errorResponse: TError }>()
);

export const getHeldWithdrawalsAPIFailed = createAction(
  '[Funding_API] Get held withdrawals Failed',
  props<{ errorResponse: TError }>()
);

export const depositOnlineCheckAPIFailed = createAction(
  '[Funding_API] Deposit online check ACH Failed',
  props<{ errorResponse: TError }>()
);

export const addAchAccountAPIFailed = createAction(
  '[Funding_API] Add ach account Failed',
  props<{ errorResponse: TError }>()
);

export const deleteAchAccountAPIFailed = createAction(
  '[Funding_API] Delete ach account Failed',
  props<{ errorResponse: TError }>()
);

export const withdrawCheckByEmailAPIFailed = createAction(
  '[Funding_API] Withdraw amount using check by email Failed',
  props<{ errorResponse: TError }>()
);

export const withdrawOnlineCheckAPIFailed = createAction(
  '[Funding_API] Withdraw online check ACH Failed',
  props<{ errorResponse: TError }>()
);

/**
 * Properties
 */
export const setError = createAction(
  '[Funding] Set an error',
  props<{ error: TError }>()
);

export const setCards = createAction(
  '[Funding] Set cards',
  props<{ cards: any }>()
);
